import Navbar from "@/pages/home/components/Navbar";
import HeroSection from "@/pages/home/components/HeroSection";

export default function Home() {
  return (
    <div className="relative min-h-screen w-full bg-[#2b1a1a]">
      <Navbar />
      <HeroSection />
    </div>
  );
}